import fr from '@/plugins/i18n/dateTimeFormats/fr'
import en from '@/plugins/i18n/dateTimeFormats/en'

export default {
  en,
  fr,
}
